import { Horse_show_entry } from './horse_show_entry';
import { Entry_type } from './entry_type';

export class Horse_show_entry_with_types extends Horse_show_entry {
	entry_type_objects: Entry_type[] = [];
	stall_warning: boolean = false;
	
	constructor(values: Object = {}) {
		super(values);
		Object.assign(this, values);
	}

}